export default function draw() {
  let i = 0;
  while (this.anims[i]) {
    this.anims[i].draw();
    i++;
  }
  this.ctx.beginPath();

  !this.hide &&
    this.ctx.arc(this.ball.x, this.ball.y, this.ballRadius, 0, Math.PI * 2);

  this.ctx.fillStyle = "#ffb000";
  this.ctx.fill();
}
